export default __webpack_public_path__ + "static/media/widget_watchbox_vpmesc1_sell.e2091d1d.mp3";